export function setValidationStatusClass(el) {
    return {
      correct: el.$dirty && !el.$errors.length,
      error: el.$errors.length || (el.$dirty && !el.$model),
    };
  }